"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("./styles");

var _ButtonV = require("../../atoms/ButtonV2");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _utils = require("../../../global-files/utils");

var _jsxRuntime = require("react/jsx-runtime");

/* Este es un menu de opciones tipo select donde cada item
es un boton con su propio onClick */
var Dropdown = function Dropdown(props) {
  var _positions$positionDr;

  var items = props.items,
      triggerType = props.triggerType,
      children = props.children,
      maxWidthDropdown = props.maxWidthDropdown,
      maxHeightDropdown = props.maxHeightDropdown,
      className = props.className,
      classNameDropdown = props.classNameDropdown,
      positionDropdown = props.positionDropdown;
  var positions = {
    topStart: "top-start",
    topEnd: "top-end",
    topCenter: "top",
    rightStart: "right-start",
    rightEnd: "right-end",
    rightCenter: "right",
    bottomStart: "bottom-start",
    bottomEnd: "bottom-end",
    bottomCenter: "bottom",
    leftStart: "left-start",
    leftEnd: "left-end",
    leftCenter: "left"
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showDropdown = _useState2[0],
      setShowDropdown = _useState2[1];

  var renderItems = function renderItems() {
    var customItems = [];

    if (!(0, _utils.isArrayEmpty)(items)) {
      var useIconDefault = items.some(function (item) {
        return item.icon ? true : false;
      });
      items.forEach(function (item, index) {
        var _item$icon;

        customItems.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
          className: "dropdownItem" + (useIconDefault ? item.icon ? "" : " iconDefault" : ""),
          type: "whiteS3",
          borderType: undefined,
          size: 12,
          disabled: item.disabled,
          isLoading: item.isLoading,
          label: (0, _utils.isStringEmpty)(item.label) ? undefined : item.label,
          icon: useIconDefault ? (_item$icon = item.icon) !== null && _item$icon !== void 0 ? _item$icon : _freeSolidSvgIcons.faCircle : undefined,
          onClick: function onClick(event) {
            event.stopPropagation();
            setTimeout(function () {
              setShowDropdown(false);
              item.onClick && item.onClick(event);
            }, 200);
          }
        }, "item-" + index));
      });
    }

    return customItems;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ClickAwayListener, {
    onClickAway: function onClickAway(event) {
      if (triggerType !== "hover") setShowDropdown(false);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      className: !(0, _utils.isStringEmpty)(className) ? className : "",
      maxWidthDropdown: maxWidthDropdown,
      maxHeightDropdown: maxHeightDropdown,
      onMouseEnter: function onMouseEnter(event) {
        if (triggerType === "hover") {
          setShowDropdown(true);
        }
      },
      onMouseLeave: function onMouseLeave(event) {
        if (triggerType === "hover") {
          setShowDropdown(false);
        }
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
        placement: (_positions$positionDr = positions[positionDropdown]) !== null && _positions$positionDr !== void 0 ? _positions$positionDr : positions.bottomStart,
        open: showDropdown,
        arrow: false,
        componentsProps: {
          tooltip: {
            className: "dropdownMenu" + ((0, _utils.isStringEmpty)(classNameDropdown) ? "" : " " + classNameDropdown)
          },
          popper: {
            disablePortal: true
          },
          transition: {
            timeout: 300
          }
        },
        TransitionComponent: _material.Fade,
        enterDelay: 100,
        followCursor: false,
        disableFocusListener: true,
        disableTouchListener: true,
        disableHoverListener: true,
        title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: renderItems()
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "containerIntern",
          onClick: function onClick(event) {
            if (triggerType !== "hover") {
              setShowDropdown(!showDropdown);
            }
          },
          children: children
        })
      })
    })
  });
};

exports.Dropdown = Dropdown;